export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  useHead({
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk}${runtimeConfig?.public?.seo?.postfix || ''}` : (runtimeConfig.title || '');
    }
  });
});
